import * as React from 'react';

import { IGlob } from '../../ts/Glob';
import { config } from '../../ts/config';
import { ILoadingPanelOptions } from '../../ts/stores/NotificationsStore';
import { LoadIndicator } from 'devextreme-react/load-indicator';

export interface ILoadingPanelProps {
    runTimeWidgetID: number;
    options: ILoadingPanelOptions;
    glob: IGlob;
}

function getLoadingPanel(props: ILoadingPanelProps) {
    const { loadingPanels } = props.glob.NotificationsStore.getState();

    return props.runTimeWidgetID != null && loadingPanels != null ? loadingPanels[props.runTimeWidgetID] : null;
}

export default function LoadingPanel(props: ILoadingPanelProps) {
    const [loadingPanel, setLoadingPanel] = React.useState(getLoadingPanel(props));

    React.useState(() => {
        const handleNotificationEvent = () => {
            setLoadingPanel(getLoadingPanel(props));
        };

        props.glob.NotificationsStore.addOnInWidgetNotificationListener(handleNotificationEvent);

        return () => {
            props.glob.NotificationsStore.removeOnInWidgetNotificationListener(handleNotificationEvent);
        };
    });

    let content: React.JSX.Element = null;

    if (loadingPanel != null) {
        const buttonTitle = props.options?.buttonTitle || 'Cancel';
        const size = props.options?.size || 'medium';

        if (config.LAYOUT_TYPE !== 'narrow' && props.options?.canCancelQuery === true) {
            const handleOnLoadingPanelClick = (e) => {
                props.glob.AQLQueries.cancelQueries({
                    runTimeWidgetID: props.runTimeWidgetID
                });
            };

            let buttonSize = '';
            switch (size) {
                case 'small':
                    buttonSize = 'btn-sm';
                    break;
                case 'large':
                    buttonSize = 'btn-lg';
                    break;
                default:
                    buttonSize = '';
                    break;
            }
            content = (
                <button
                    className={'btn btn-default loading-panel ' + buttonSize}
                    title={buttonTitle}
                    onClick={handleOnLoadingPanelClick}
                >
                    <div className="d-flex align-items-center">
                        <LoadIndicator className={size + '-indicator'} />
                        <span className="ml-1">{buttonTitle}</span>
                    </div>
                </button>
            );
        } else {
            content = <LoadIndicator className={size + '-indicator loading-panel'} />;
        }

        return <div className="widget-loading-notification">{content}</div>;
    } else {
        return null;
    }
}

